import HomeCard from "../HomeCard";
import "./HomeCard1.css";

const HomeCard1 = () => {
    return <HomeCard className={"home-card-1"} itemType={"zepeto"} itemKey={2} itemName="DIGICO KT" itemDesc="메타버스에 그려낸 KT의 미래기술" />
};

export default HomeCard1;
